module.exports = __webpack_public_path__ + "img/Square_3.34c84424.jpg";